<template>
    <option value="ethernet">ethernet</option>
    <option value="cellular">cellular</option>
    <option value="wifi">wifi</option>
</template>
